import classNames from 'classnames/bind';
import styles from './Complete.module.css';
import feedback_password from '../../../../assets/images/login/feedback_password.svg';
import feedback_failed from '../../../../assets/images/login/feedback_payment_failed.svg';
import {
  ADDED_MANAGEMENT_PERSONNEL,
  ADDED_MANAGEMENT_PERSONNEL_DESC,
  ADD_PERSONNEL_SUCCESS,
  AI_LEARNING_TOOL,
  ANNUAL,
  CARD_UPDATED_FAIL,
  CARD_UPDATED_SUCCESS,
  CHANGED_MEMBERSHIP,
  CHANGED_MEMBERSHIP_DESC,
  CLASS_MANAGEMENT_PERSONNEL,
  CLASS_MANAGEMENT_PERSONNEL_ADDITION,
  COMPLETE,
  CONTACT_ADMIN_ISSUE,
  CURRENCY_UNIT,
  HEADCOUNT,
  INSTALLMENTS,
  MEMBERSHIP,
  MEMBERSHIP_CHANGE_MESSAGE,
  MONTHLY,
  MONTHLY_INSTALLMENTS,
  NEXT_PAYMENT_AMOUNT,
  NEXT_PAYMENT_DATE,
  ORIGINAL_MEMBERSHIP,
  PAYMENT_COMPLETE_MESSAGE,
  PAYMENT_FAILED_MESSAGE,
  PAYMENT_METHOD,
  PREV,
  SUBSCRIPTION_PERIOD,
} from '../../../../constants';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../../../utils/date';

interface Complete {
  nm?: string;
  membershipId?: number;
  paymentResult?: any;
  isPersonnel?: boolean;
  resultType?: number;
}

export default function Complete({
  nm,
  membershipId,
  paymentResult,
  isPersonnel,
  resultType,
}: Complete) {
  const cx = classNames.bind(styles);
  const navigate = useNavigate();

  if (!paymentResult || paymentResult?.type === 2) {
    return (
      <div className={cx('feedback_complete')}>
        <div className={cx('feedback_box')}>
          <img src={feedback_failed} alt="" />
          <p>
            <span
              dangerouslySetInnerHTML={{
                __html:
                  nm === 'changeCard'
                    ? CARD_UPDATED_FAIL
                    : PAYMENT_FAILED_MESSAGE,
              }}
            ></span>
          </p>
          <p className={cx('desc')}>
            <span
              dangerouslySetInnerHTML={{ __html: CONTACT_ADMIN_ISSUE }}
            ></span>
          </p>
        </div>

        <div className={cx('btn_wrap')}>
          <button
            type="button"
            className={cx('btn', 'b_t', 's48')}
            onClick={() => {
              navigate('../change-card', {
                replace: true,
                state: {
                  type: isPersonnel ? 'personnel' : nm,
                  membershipId: membershipId,
                  resultType: resultType === 2 ? 0 : 2,
                },
              });
            }}
          >
            <span>{PREV}</span>
          </button>
        </div>
      </div>
    );
  }

  const { type, result } = paymentResult;

  const message =
    type === 1
      ? nm === 'changeCard'
        ? CARD_UPDATED_SUCCESS
        : PAYMENT_COMPLETE_MESSAGE.replace(
            '{amount}',
            (result?.paymentPrice as number)?.toLocaleString()
          )
      : type === 2
        ? PAYMENT_FAILED_MESSAGE
        : type === 3
          ? MEMBERSHIP_CHANGE_MESSAGE
          : type === 4
            ? CARD_UPDATED_SUCCESS
            : isPersonnel
              ? ADD_PERSONNEL_SUCCESS
              : CARD_UPDATED_FAIL;

  const resultList = isPersonnel
    ? [
        {
          name: ADDED_MANAGEMENT_PERSONNEL,
          value: `${paymentResult?.membershipInfo?.capacityStudentExt}${HEADCOUNT}`,
        },
      ]
    : [
        { name: MEMBERSHIP, value: result?.membership.description },
        {
          name: SUBSCRIPTION_PERIOD,
          value: `${formatDate(result?.startDate as string)} ~ ${formatDate(
            result?.endDate as string
          )}`,
        },
        {
          name: NEXT_PAYMENT_DATE,
          value: formatDate(result?.nextPaymentDate as string),
        },
        {
          name: AI_LEARNING_TOOL,
          value: result?.aitoolService,
        },
        {
          name: CLASS_MANAGEMENT_PERSONNEL,
          value: `${result?.capacityStudent} (${HEADCOUNT})`,
        },
        {
          name: CLASS_MANAGEMENT_PERSONNEL_ADDITION,
          value: `${result?.capacityStudentExt} (${HEADCOUNT})`,
        },
        {
          name: MONTHLY_INSTALLMENTS,
          value: INSTALLMENTS[result?.cardQuota as string],
        },
        {
          name: NEXT_PAYMENT_AMOUNT,
          value: CURRENCY_UNIT + result?.nextPaymentPrice?.toLocaleString(),
        },
        { name: PAYMENT_METHOD, value: result?.paymentMethod },
      ];

  const movePage = () => {
    const to =
      type === 1
        ? nm === 'changeCard'
          ? '../membership'
          : '/home/library'
        : type === 3 || type === 4 || isPersonnel
          ? '../membership'
          : '../change-card';
    navigate(to, {
      replace: true,
      state: {
        type: result?.membership.nm,
        membershipId: result?.membership.membershipId ?? membershipId,
        resultType: type,
      },
    });
  };

  return (
    <div className={cx('feedback_complete')}>
      <div className={cx('feedback_box')}>
        <img
          src={type === 2 || type === 5 ? feedback_failed : feedback_password}
          alt=""
        />
        <p>
          <span dangerouslySetInnerHTML={{ __html: message }}></span>
        </p>
        {((type === 1 && nm !== 'changeCard') || isPersonnel) && (
          <>
            <div className={cx('feedback_list')}>
              {resultList.map(({ name, value }) => (
                <div key={name} className={cx('row')}>
                  <span className={cx('sub', { w200: isPersonnel })}>
                    {name}
                  </span>
                  <span className={cx('detail')}>{value}</span>
                </div>
              ))}
            </div>
            {isPersonnel && (
              <p
                className={cx('desc')}
                dangerouslySetInnerHTML={{
                  __html: ADDED_MANAGEMENT_PERSONNEL_DESC,
                }}
              ></p>
            )}
          </>
        )}
        {(type === 2 || type === 5) && (
          <p className={cx('desc')}>
            <span
              dangerouslySetInnerHTML={{ __html: CONTACT_ADMIN_ISSUE }}
            ></span>
          </p>
        )}
        {type === 3 && (
          <>
            <ul>
              <li>
                <span className={cx('sub')}>{ORIGINAL_MEMBERSHIP}</span>
                <span className={cx('detail')}>
                  <span className={cx('type_plan')}>
                    {result?.prevMembership?.nm}
                  </span>
                  <span className={cx('type_monthly')}>
                    {' '}
                    (
                    {result?.prevMembership?.paymentPeriod === 'month'
                      ? MONTHLY
                      : ANNUAL}
                    )
                  </span>
                </span>
              </li>
              <li>
                <svg
                  width="64"
                  height="37"
                  viewBox="0 0 64 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M52 0H12V20L0 20L32 37L64 20L52 20V0Z"
                    fill="url(#paint0_linear_6252_439512)"
                  ></path>
                  <defs>
                    <linearGradient
                      id="paint0_linear_6252_439512"
                      x1="32"
                      y1="0"
                      x2="32"
                      y2="37"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop
                        offset="0"
                        stopColor="white"
                        stopOpacity="60%"
                      ></stop>
                      <stop offset="1" stopColor="#BDBDBD"></stop>
                    </linearGradient>
                  </defs>
                </svg>
              </li>
              <li>
                <span className={cx('sub')}>{CHANGED_MEMBERSHIP}</span>
                <span className={cx('detail')}>
                  <span className={cx('type_plan')}>
                    {result?.membership.nm}
                  </span>
                  <span className={cx('type_monthly')}>
                    {' '}
                    (
                    {result?.membership.paymentPeriod === 'month'
                      ? MONTHLY
                      : ANNUAL}
                    )
                  </span>
                </span>
              </li>
            </ul>
            <p className={cx('desc')}>
              <span
                dangerouslySetInnerHTML={{ __html: CHANGED_MEMBERSHIP_DESC }}
              ></span>
            </p>
          </>
        )}
      </div>

      <div className={cx('btn_wrap')}>
        <button
          type="button"
          className={cx('btn', 'b_t', 's48')}
          onClick={movePage}
        >
          <span>{type === 2 || type === 5 ? PREV : COMPLETE}</span>
        </button>
      </div>
    </div>
  );
}
